import React from 'react';
import { MusicNote } from '@landr/maestro';
import { Artwork } from './types';
import * as Styled from './styled';

const Artworks = ({
    artworks,
    imageSize,
}: {
    artworks?: [Artwork] | [Artwork, Artwork, Artwork];
    imageSize?: number;
}) => {
    let main: Artwork | undefined;
    let left: Artwork | undefined;
    let right: Artwork | undefined;

    switch (artworks?.length) {
        case 1:
            main = artworks[0];
            left = artworks[0];
            right = artworks[0];
            break;
        case 3:
            main = artworks[0];
            left = artworks[1];
            right = artworks[2];
            break;
        default:
            main = undefined;
            left = undefined;
            right = undefined;
    }

    return (
        <Styled.ArtworksWrapper>
            <Styled.BackgroundWrapper>
                <Styled.Left>
                    {!left && <Styled.ImageSkeleton aria-busy="true" />}
                    {left && (
                        <Styled.ArtworkWrapper>
                            <Styled.Artwork
                                alt=""
                                imageUrl={left.artworkUrl}
                                fallbackIcon={MusicNote}
                                isExclusive={left.isExclusive}
                                imageSize={imageSize}
                                loading="eager"
                            />
                        </Styled.ArtworkWrapper>
                    )}
                </Styled.Left>
                <Styled.Right>
                    {!right && <Styled.ImageSkeleton aria-busy="true" />}
                    {right && (
                        <Styled.ArtworkWrapper>
                            <Styled.Artwork
                                alt=""
                                imageUrl={right.artworkUrl}
                                fallbackIcon={MusicNote}
                                isExclusive={right.isExclusive}
                                imageSize={imageSize}
                                loading="eager"
                            />
                        </Styled.ArtworkWrapper>
                    )}
                </Styled.Right>
            </Styled.BackgroundWrapper>
            <Styled.MainImage>
                {!main && <Styled.ImageSkeleton aria-busy="true" />}
                {main && (
                    <Styled.ArtworkWrapper>
                        <Styled.Artwork
                            alt=""
                            imageUrl={main.artworkUrl}
                            fallbackIcon={MusicNote}
                            isExclusive={main.isExclusive}
                            imageSize={imageSize}
                            loading="eager"
                        />
                    </Styled.ArtworkWrapper>
                )}
            </Styled.MainImage>
        </Styled.ArtworksWrapper>
    );
};

export default Artworks;
